

<div class="input" [ngClass]="type">
    <p class="label">{{label}}</p>
	<div *ngIf="type === 'autocomplete'">
		<ion-icon class="_search-icon" src="./assets/icons/search-outline.svg"></ion-icon>
		<input [id]="'organizer-input-' + inputId" [ngClass]="{'_has-results': searchResults.length > 0}" (input)="autocomplete($any($event).target.value)" type="text" autocomplete="no-auto">
	</div>
	<div *ngIf="type === 'search'" class="_search-input">
		<ion-icon class="_search-icon" src="./assets/icons/search-outline.svg"></ion-icon>
		<input [id]="'organizer-input-' + inputId" type="text" autocomplete="no-auto" [(ngModel)]="searchString">
		<button type="button" class="_button _save-button" (click)="search()">
			<ion-icon src="./assets/icons/search-outline.svg"></ion-icon>
		</button>
	</div>
	<div class="_status">
		<ng-container *ngIf="loading; else result">
			<ion-spinner name="dots"></ion-spinner>
		</ng-container>
		<ng-template #result>
			<ion-icon *ngIf="error" class="_invalid" src="./assets/icons/invalid-code.svg"></ion-icon>
		</ng-template>
	</div>
	<ng-container *ngIf="type === 'autocomplete'">
		<div class="_autocomplete-results" *ngIf="searchResults.length > 0">
			<p class="_search-result" *ngFor="let result of searchResults" (click)="selectOrganizer(result)">{{ result.name | organizerName }}</p>
		</div>
	</ng-container>
	<ng-container *ngIf="type === 'search'">
		<div class="_too_much_search_results" *ngIf="searchResults.length > 10">
			<p [translate]="'TENANT.UIT_DATABASE.TOO_MUCH_RESULTS'"></p>
		</div>
	</ng-container>
	<ng-container *ngIf="type === 'search'">
		<div class="_search-results" *ngIf="loading || hasSearched || error">
			<div class="_loading-search-results" *ngIf="loading">
				<ion-spinner name="circles"></ion-spinner>
				<p [translate]="'SEARCHING'"></p>	
			</div>
			<div class="_loading-search-failed" *ngIf="error">
				<ion-icon class="_invalid" src="./assets/icons/invalid-code.svg"></ion-icon>
				<p [translate]="'TENANT.UIT_DATABASE.SEARCH_FAILED'"></p>	
			</div>
			<ng-container *ngIf="searchResults.length > 0">
				<div class="_search-result" *ngFor="let result of searchResults" (click)="selectOrganizer(result)">
					<p>{{ result.name | organizerName }}<span *ngIf="result.url" class="_inline-details"> ({{result.url}})</span></p>
					<!-- <div class="_details">
						<p *ngIf="result.address?.nl">{{result.address.nl.streetAddress}}, {{result.address.nl.postalCode}} {{result.address.nl.addressLocality}}</p>
						<p *ngIf="result.url">{{result.url}}</p>
					</div> -->
				</div>
			</ng-container>
			<ng-container *ngIf="searchResults.length === 0 && !loading && hasSearched">
				<p class="_no-search-results" [translate]="'TENANT.UIT_DATABASE.NO_RESULTS_FOUND'"></p>
			</ng-container>
		</div>
	</ng-container>
    
</div>